import { FILE_TYPES } from "@/core/constants/fileTypes";

export default {
  defaultTextInput: {
    minLength: 2,
    maxLength: 255,
  },
  AdressTextInput: {
    minLength: 2,
    maxLength: 125,
  },
  CityTextInput: {
    minLength: 2,
    maxLength: 45,
  },
  createCategory: {
    nameInput: {
      minLength: 2,
      maxLength: 255,
    },
    identifierInput: {
      minLength: 2,
      maxLength: 255,
    },
    imgInput: {
      maxFileSizeInKo: 250,
      validImgTypes: [FILE_TYPES.JPG, FILE_TYPES.PNG],
    },
    childrenDescriptionInput: {
      maxLengthWithoutHtml: 255,
    },
  },
  createProduct: {
    nameInput: {
      nameMinLength: 2,
      nameMaxLength: 255,
    },
    imgInput: {
      maxFileSizeInKo: 250,
      validImgTypes: [FILE_TYPES.JPG, FILE_TYPES.PNG],
      maxNumberFile: 1,
    },
    priceInput: {
      minValue: 0,
      maxValue: 50000,
    },
    commentInput: {
      maxLength: 500,
    },
  },
  createQuestion: {
    questionInputs: {
      nameMinLength: 2,
      nameMaxLength: 255,
      descMaxLength: 3000,
    },
    answersInputs: {
      nameMinLength: 2,
      nameMaxLength: 255,
      descMaxLength: 3000,
    },
  },
  design: {
    defaultLogo: {
      maxFileSizeInKo: 250,
      validImgTypes: [FILE_TYPES.JPG, FILE_TYPES.PNG],
    },
    faviconLogo: {
      maxFileSizeInKo: 20,
      validImgTypes: [...FILE_TYPES.ICO, FILE_TYPES.PNG],
    },
  },
  paymentMode: {
    label: {
      minLength: 1,
      maxLength: 255,
    },
    description: {
      minLength: 2,
      maxLength: 300,
    },
    longDescription: {
      minLength: 0,
      maxLength: 800,
      maxNbLines: 15,
    },
    mailContent: {
      minLength: 0,
      maxLength: 300,
    },
  },
  transferOrder: {
    cgs: {
      minLength: 2,
      maxLength: 5000,
    },
  },
  circuit: {
    description: {
      minLength: 0,
      maxLengthWithoutHtml: 500,
    },
    instructions: {
      countMax: 6,
      instruction: {
        maxLength: 150,
        minLength: 1,
      },
    },
  },
  customHome: {
    metaTitle: {
      minLength: 2,
      maxLength: 255,
    },
    metaDescription: {
      minLength: 2,
      maxLength: 500,
    },
    cmsWidgets: {
      search: {
        bannerTitle: {
          minLength: 2,
          maxLength: 50,
        },
        bannerImage: {
          maxFileSizeInKo: 250,
          validImgTypes: [FILE_TYPES.JPG, FILE_TYPES.PNG],
        },
      },
      customHtml: {
        minLength: 20,
        maxLength: 200000,
      },
    },
  },
  cart: {
    maxNbOfItems: 200,
    timeToLiveInDays: {
      inPublicApp: 30,
      inDashboardApp: 1,
    },
  },
  search: {
    nbOfItemsPerPage: 40,
  },
  defaultLongitudeInput: {
    minValue: -180,
    maxValue: 180,
  },
  defaultLatitudeInput: {
    minValue: -90,
    maxValue: 90,
  },
  pdfInput: {
    maxFileSizeInKo: 250,
    validPdfTypes: [FILE_TYPES.PDF],
    maxNumberFile: 1,
  },
};
